export default __webpack_public_path__ + "static/media/figure-triangle.74702d55.svg";